import type { CommandRegistry } from '../../types/commands'

export const easterEggCommands: CommandRegistry = {
  konami: {
    name: 'konami',
    description: 'A classic code',
    hidden: true,
    category: 'easter-egg',
    execute: () => [
      {
        type: 'success',
        content: `
🎮 KONAMI CODE ACTIVATED! 🎮

   ↑ ↑ ↓ ↓ ← → ← → B A

You've unlocked: Extra Life in Portfolio Browsing!

Just kidding... but respect for knowing the code 🫡
`,
      },
    ],
  },

  matrix: {
    name: 'matrix',
    description: 'Enter the matrix',
    hidden: true,
    category: 'easter-egg',
    execute: () => [
      {
        type: 'success',
        content: `
╔═══════════════════════════════════════════════════════════╗
║    01001101 01000001 01010100 01010010 01001001 01011000  ║
╚═══════════════════════════════════════════════════════════╝

Wake up, Neo...

The Matrix has you...

Follow the white rabbit.

         🐰

Knock, knock.

▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀
[ Matrix mode: ACTIVATED ]
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
`,
      },
    ],
  },

  hack: {
    name: 'hack',
    description: 'Hacking sequence',
    hidden: true,
    category: 'easter-egg',
    execute: () => [
      {
        type: 'success',
        content: `
///////////////////////////////////////////////////////////
//  [INITIATING HACK SEQUENCE...]                       //
///////////////////////////////////////////////////////////

> Accessing mainframe...............  [████████████] 100%
> Bypassing firewall...............   [████████████] 100%
> Cracking encryption..............   [████████████] 100%
> Downloading secret files.........   [████████████] 100%

┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
┃  [HACK COMPLETE]                                        ┃
┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

Secret files revealed:
  📄 anderson_likes_coffee.txt
  📄 empathy_is_a_superpower.md
  📄 tabs_vs_spaces_peace_treaty.pdf

~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~
 😄 Just kidding! Ethical hacking only!
~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~
`,
      },
    ],
  },

  sudo: {
    name: 'sudo',
    description: 'Superuser privileges',
    hidden: true,
    category: 'easter-egg',
    execute: (args) => {
      const command = args.join(' ')
      return [
        {
          type: 'error',
          content: `
anderson is not in the sudoers file.
This incident will be reported.

(To: anderson@can.code)

Just kidding! But nice try 😉

Command: ${command || '(none)'}
`,
        },
      ]
    },
  },

  coffee: {
    name: 'coffee',
    description: 'Make coffee',
    hidden: true,
    category: 'easter-egg',
    execute: () => [
      {
        type: 'info',
        content: `
╔═══════════════════════════════════════════════════════════╗
║                  COFFEE BREWING INITIATED                  ║
╚═══════════════════════════════════════════════════════════╝

        (  )   (   )  )
         ) (   )  (  (
         ( )  (    ) )
         _____________
        <_____________> ___
        |             |/ _ \\
        |   COFFEE   | | | |
        |             |\_| |
         \___________/  \_/

☕ Brewing fresh coffee...        [████████████] 100%

Ah, much better! Ready to code now.

~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~
 (HTTP 418: I'm a teapot... wait, wrong beverage)
~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~
`,
      },
    ],
  },

  '42': {
    name: '42',
    description: 'The answer',
    hidden: true,
    category: 'easter-egg',
    execute: () => [
      {
        type: 'info',
        content: `
The Answer to the Ultimate Question of
Life, the Universe, and Everything is...

              42

But what was the question again? 🤔

(Deep Thought has been computing this for
7.5 million years)
`,
      },
    ],
  },

  whoami: {
    name: 'whoami',
    description: 'Existential question',
    aliases: ['who'],
    hidden: false, // This one is actually useful
    category: 'info',
    execute: () => [
      {
        type: 'info',
        content: `
anderson

(Deep question though... aren't we all just
 trying to figure that out?)

Try 'about' for more concrete details 😄
`,
      },
    ],
  },

  hello: {
    name: 'hello',
    description: 'Say hello',
    hidden: true,
    category: 'easter-egg',
    execute: () => [
      {
        type: 'success',
        content: `
Hello, World!

Welcome to my portfolio! 👋

I'm Anderson Reinkordt, and I'm glad you're here.

Type 'about' to learn more about me, or 'help'
to see what else you can do.

Let's build something amazing together! ✨
`,
      },
    ],
  },

  play: {
    name: 'play',
    description: 'Play background music',
    hidden: true,
    category: 'easter-egg',
    execute: () => [
      {
        type: 'success',
        content: '__PLAY_AUDIO__',
      },
    ],
  },

  thanks: {
    name: 'thanks',
    description: 'Show gratitude',
    aliases: ['thank you', 'thankyou'],
    hidden: true,
    category: 'easter-egg',
    execute: () => [
      {
        type: 'success',
        content: `
You're very welcome! 😊

Thank YOU for taking the time to explore
my portfolio.

Your interest means a lot!

Feel free to reach out via 'contact' if
you'd like to connect.
`,
      },
    ],
  },
}
